module.exports = __webpack_public_path__ + "img/color-r-2.943eae4.webp";